<script>
import { h } from 'vue'
import { RichTextView } from '@addictivegroup/addictive-richtext/vue'
import RecordLink from './RecordLink.vue'
import { ENTITIES } from '@/lib/entities.js'

/**
 * A note or a description shown, not edited: addictive-richtext's view of the JSON (never raw
 * HTML, so a note can carry nothing executable), mentions of records drawn as links to them, the
 * text private where privacy mode hides it (D-260).
 */
const mention = (node, key) => {
  const [entity, uuid] = String(node.attrs?.id || '').split(':')
  const label = `@${node.attrs?.label || ''}`
  if (ENTITIES[entity] && uuid) return h(RecordLink, { key, class: 'mention', entity, uuid }, () => label)
  return h('span', { key, class: 'mention' }, label)
}

export default {
  name: 'RichText',
  props: { doc: { type: [Object, null], default: null }, fallback: { type: String, default: '' } },
  setup(props) {
    return () => h(RichTextView, { doc: props.doc, fallback: props.fallback, nodes: { mention }, attrs: { 'data-private': '' } })
  },
}
</script>
